import { API_URL } from "../config/config"
import { patchRequest } from "../utils/axiosUtils"

export const updateStatus = async ({ id, status, type, reason }) => {
  if (!id || !status || !type) {
    throw new Error('Missing id, status, or type for status update');
  }

  if (status === 'rework' && (!reason || !reason.trim())) {
    throw new Error("Reason is required when setting status to 'rework'.");
  }

  try {
    const payload = { id, status, type: String(type).toLowerCase() };
    if (reason) payload.reason = reason;

    const response = await patchRequest({
      url: `${API_URL}/status`,
      data: payload,
      headers: { 'Content-Type': 'application/json' },
    });

    if (response?.data?.success === false) {
      const customError = new Error(response.data.message || 'Status update failed');
      customError.fieldErrors = response.data.errors || {};
      throw customError;
    }

    return response.data;
  } catch (err) {
    const res = err?.response?.data;
    if (res) {
      const customError = new Error(res.message || 'Status update failed');
      customError.fieldErrors = res.errors || {};
      throw customError;
    }
    throw new Error(err.message || 'Unknown error occurred');
  }
};
